// Module
var code = "<!-- ko foreach: _statuses --> <h1 data-bind=\"text: Environment\"></h1> <!-- ko foreach: DeviceStatus --> <div data-bind=\"text: $data\"></div> <!-- /ko --> <!-- /ko -->";
// Exports
export default code;